export default "uniform mat4 u_MVPMatrix;\nuniform mat4 u_ModelMatrix;\nuniform mat4 u_NormalMatrix;\n";
//# sourceMappingURL=project2.vertex.glsl.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@luma.gl/shadertools/dist/esm/modules/project2/project2.vertex.glsl.js
// module id = 1503
// module chunks = 0